import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: 'auto' }}>
      <h1>Privacy Policy for Total Urgent Health (TUH)</h1>
      <p>
        <em>Last Updated: [14-Aug-2024]</em>
      </p>

      <h2>Introduction</h2>
      <p>
        Big Ideas Services, LLC ("we", "us", "our") is committed to protecting
        and respecting your privacy. This Privacy Policy explains how we
        collect, use, share, and protect personal information when you
        communicate with us via WhatsApp.
      </p>
      <p>
        By interacting with us on WhatsApp, you agree to the practices described
        in this Privacy Policy.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        When you communicate with us via WhatsApp, we may collect the following
        types of personal information:
      </p>
      <ul>
        <li>
          <strong>Personal Identifiers:</strong> Your name, phone number, and
          any other information you provide during our communications.
        </li>
        <li>
          <strong>Message Content:</strong> Any messages, including text,
          images, videos, and other content you send to us via WhatsApp.
        </li>
        <li>
          <strong>Technical Data:</strong> Information about your device and
          usage, such as IP address, device type, and operating system.
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We use the information we collect to:</p>
      <ul>
        <li>
          <strong>Provide Services:</strong> Respond to your inquiries, provide
          customer support, and deliver services you request.
        </li>
        <li>
          <strong>Improve Our Services:</strong> Analyze usage patterns to
          improve our offerings and user experience.
        </li>
        <li>
          <strong>Marketing Communications:</strong> With your consent, send you
          promotional messages and offers.
        </li>
        <li>
          <strong>Legal Compliance:</strong> Comply with legal obligations and
          protect our rights.
        </li>
      </ul>

      <h2>3. Sharing Your Information</h2>
      <p>We may share your information with:</p>
      <ul>
        <li>
          <strong>Service Providers:</strong> Third-party providers who assist
          us in operating our business, such as WhatsApp (a service provided by
          Facebook Inc.) and other IT and hosting service providers.
        </li>
        <li>
          <strong>Legal Obligations:</strong> Law enforcement or government
          authorities when required by law or to protect our legal rights.
        </li>
        <li>
          <strong>Business Transfers:</strong> In the event of a merger,
          acquisition, or sale of all or part of our assets, your information
          may be transferred to the new owner.
        </li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We take the security of your personal information seriously. We
        implement appropriate technical and organizational measures to protect
        your data from unauthorized access, disclosure, alteration, or
        destruction.
      </p>

      <h2>5. Your Rights</h2>
      <p>
        Depending on your location, you may have the following rights regarding
        your personal information:
      </p>
      <ul>
        <li>
          <strong>Access:</strong> Request access to the personal information we
          hold about you.
        </li>
        <li>
          <strong>Correction:</strong> Request that we correct any inaccuracies
          in your personal information.
        </li>
        <li>
          <strong>Deletion:</strong> Request the deletion of your personal
          information, subject to certain exceptions.
        </li>
        <li>
          <strong>Opt-Out:</strong> Opt-out of receiving marketing
          communications from us.
        </li>
      </ul>
      <p>
        To exercise your rights, please contact us at [Your Contact
        Information].
      </p>

      <h2>6. Data Retention</h2>
      <p>
        We retain your personal information only for as long as necessary to
        fulfill the purposes outlined in this Privacy Policy, unless a longer
        retention period is required or permitted by law.
      </p>

      <h2>7. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page with an updated effective date. We encourage you to
        review this Privacy Policy periodically.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy or our
        data practices, please contact us at:
      </p>
      <p>
        Big Ideas Services, LLC
        <br />
        support 312-932-8370
        <br />
        info@totalurgenthealth.com
        <br />
        312-932-8370
      </p>
    </div>
  );
};

export default PrivacyPolicy;
